export default function (str) {
	return str
}



// WEBPACK FOOTER //
// ./src/utils/language.js